import { Dispatch } from 'redux';

import { actions } from '../../modules/Actions';
import { LOADING_TYPE } from '../../reducers/LoadingStatusReducer';
import { SORRY_MESSAGE_TYPE } from '../../reducers/SorryMessageReducer';
import { customerListApi, CustomerListApiRequest, CustomerListApiResponse } from '../../../external/CustomerListApi';

export interface FetchCustomerListKey {
  customerId: string;
}

/**
 * ステータスを更新しつつ、顧客一覧データを取得する
 * @param key API検索キー(customerId)
 * @param dispatch
 */
export const updateRefresh = async (request: CustomerListApiRequest, dispatch: Dispatch): Promise<CustomerListApiResponse> => {
  const refresh = async () => {
    return fetchCustomerInfoList(request, dispatch);
  };
  dispatch(actions.updateRefresh({ refresh }));
  return await refresh();
};

const fetchCustomerInfoList = async (request: CustomerListApiRequest, dispatch: Dispatch): Promise<CustomerListApiResponse> => {
  dispatch(actions.updateLoadingStatus.started(LOADING_TYPE.FETCH_CUSTOMER_INFO_LIST));
  try {
    const response = await customerListApi(request);
    const { result } = response;

    dispatch(
      actions.updateLoadingStatus.done({
        params: LOADING_TYPE.FETCH_CUSTOMER_INFO_LIST,
        result: result,
      }),
    );
    return response;
  } catch (error) {
    dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.SYSTEM_ERROR));
    dispatch(
      actions.updateLoadingStatus.failed({
        params: LOADING_TYPE.FETCH_CUSTOMER_INFO_LIST,
        error: {},
      }),
    );
    return {
      hit: 0,
      customerResult: [],
      result: {
        jobDateTime: '',
        resultCd: '',
        resultMessageDtoList: [],
      },
    };
  }
};
